import Vue from "vue";
import Router from "vue-router";
import Dashboard from "@/components/Dashboard";
import CreatePrize from "@/components/CreatePrize";
import PerformDraw from "@/components/PerformDraw";
import DrawSummary from "@/components/DrawSummary";
import AuditHistory from "@/components/AuditHistory";
import PublicDrawSettings from "@/components/PublicDrawSettings";
import AnimatedSpin from "@/components/AnimatedSpin";
import Thankyou from "@/components/Thankyou";

Vue.use(Router);
export default new Router({
  routes: [
    {
      path: "/history",
      name: "AuditHistory",
      component: AuditHistory
    },
    {
      path: "/",
      name: "Dashboard",
      component: Dashboard
    },
    {
      path: "/deleted-prizes",
      name: "DeletedPrizes",
      component: Dashboard,
      props: true
    },
    {
      path: "/create-prize",
      name: "CreatePrize",
      component: CreatePrize,
      props: true
    },
    {
      path: "/edit-prize",
      name: "EditPrize",
      component: CreatePrize,
      props: true
    },
    {
      path: "/perform-draw",
      name: "PerformDraw",
      component: PerformDraw,
      props: true
    },
    {
      path: "/draw-summary",
      name: "DrawSummary",
      component: DrawSummary,
      props: true
    },
    {
      path: "/draw-settings",
      name: "PublicDrawSettings",
      component: PublicDrawSettings,
      props: true
    },
    {
      path: "/perform-public-draw",
      name: "PerformPublicDraw",
      component: AnimatedSpin,
      props: true
    },
    {
      path: "/thank-you",
      name: "Thankyou",
      component: Thankyou,
      props: true
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js